import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

// Aba "Caixa de Entrada" (notificações) removida do menu — deep links redirecionam
// para Conversas (home) para não deixar tela órfã.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    redirect: to => ({
      name: 'home',
      params: { accountId: to.params.accountId },
    }),
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
  {
    path: frontendURL('accounts/:accountId/inbox-view/:type/:id'),
    redirect: to => ({
      name: 'home',
      params: { accountId: to.params.accountId },
    }),
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
